
import vacature from '~/graphql/queries/vacature.gql';

export default {
  auth: false,
  apollo: {
    vacature: {
      query: vacature,
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
    },
  },
  data() {
    return {
      vacature: {},
    };
  },
  head() {
    return {
      title: this?.vacature?.title,
    };
  },
  computed: {
    logoPath() {
      if (this.vacature.logo.length < 1) {
        return require('~/assets/img/logo.svg');
      }

      return this.vacature.logo[0].url;
    },
    website() {
      if (!this.vacature.website) {
        return null;
      }

      if (this.vacature.website.includes('https://') || this.vacature.website.includes('http://')) {
        return this.vacature.website;
      }
      return 'https://' + this.vacature.website;
    },
    map() {
      if (!((this.vacature.straatnaam && this.vacature.huisnummer) || this.vacature.postcode || this.vacature.plaatsnaam || this.vacature.land)) {
        return null;
      }

      return `https://www.google.com/maps/dir/?api=1&destination=${
        [this.vacature.straatnaam, this.vacature.huisnummer, this.vacature.plaatsnaam, this.vacature.land].filter(v => !!v).join('+')
      }`;
    },
  },
  methods: {
    apply() {
      this.$gtm.push({
        event: 'apply',
        vacancy: {
          id: this.vacature.id,
          title: this.vacature.title,
          company: this.vacature.bedrijfsnaam,
          slug: this.vacature.slug,
          website: this.vacature.website,
        },
      });

      window.open(this.vacature.sollicitatie_url ?? ('mailto:' + this.vacature.email));
    },
  },
};
